/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PressReleaseMediaListData,
    PressReleaseMediaListDataFromJSON,
    PressReleaseMediaListDataFromJSONTyped,
    PressReleaseMediaListDataToJSON,
} from './PressReleaseMediaListData';

/**
 * GET /press_release/{release_id}/media_list
 * @export
 * @interface GetPressReleaseMediaListResponse
 */
export interface GetPressReleaseMediaListResponse {
    /**
     * 
     * @type {number}
     * @memberof GetPressReleaseMediaListResponse
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof GetPressReleaseMediaListResponse
     */
    message: string;
    /**
     * 
     * @type {PressReleaseMediaListData}
     * @memberof GetPressReleaseMediaListResponse
     */
    data: PressReleaseMediaListData;
}

export function GetPressReleaseMediaListResponseFromJSON(json: any): GetPressReleaseMediaListResponse {
    return GetPressReleaseMediaListResponseFromJSONTyped(json, false);
}

export function GetPressReleaseMediaListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPressReleaseMediaListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': PressReleaseMediaListDataFromJSON(json['data']),
    };
}

export function GetPressReleaseMediaListResponseToJSON(value?: GetPressReleaseMediaListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': PressReleaseMediaListDataToJSON(value.data),
    };
}

